import './SecuritySection.css';
import sentinelImage from '../assets/maritime_monitoring_system.jpeg';

const SecuritySection = () => {
  return (
    <section className="security" id="security">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <span className="section-label">Maritime Security</span>
          <h2 className="section-title">
            Maritime Monitoring
            <span className="gradient-text"> Systems</span>
          </h2>
          <p className="section-subtitle">
            Passive underwater surveillance for defence and critical infrastructure protection.
          </p>
        </div>

        {/* Security Product */}
        <div className="security-card">
          <div className="security-content">
            <div className="security-badge">Monitoring System</div>
            <h3 className="security-name">SENTINEL</h3>
            <p className="security-tagline">Maritime Area Security Monitoring System</p>
            <p className="security-description">
              Continuous underwater situational awareness through passive acoustic and vibration sensing.
              AI-driven detection identifies divers, anchors, unmanned systems, and other threats near
              cables, ports, and strategic assets—providing early warning before damage occurs.
            </p>

            <div className="security-features">
              <div className="security-feature">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                <span>Passive Detection</span>
              </div>
              <div className="security-feature">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 6v6l4 2"/>
                </svg>
                <span>Real-time Alerts</span>
              </div>
              <div className="security-feature">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="3" width="20" height="14" rx="2"/>
                  <path d="M8 21h8M12 17v4"/>
                </svg>
                <span>AIS Integration</span>
              </div>
              <div className="security-feature">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                </svg>
                <span>Modular & Scalable</span>
              </div>
            </div>

            <div className="security-applications">
              <span className="applications-label">Applications</span>
              <div className="application-tags">
                <div className="application-tag">Port Security</div>
                <div className="application-tag">Offshore Infrastructure</div>
                <div className="application-tag">Cable Protection</div>
                <div className="application-tag">Coastal Defence</div>
              </div>
            </div>
          </div>

          <div className="security-visual">
            <img src={sentinelImage} alt="SENTINEL Maritime Monitoring System" className="security-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;
